var _ConfigProvider$Confi;

import { ConfigProvider } from 'antd';
import { ConfigConsumer } from "antd/es/config-provider";
var MergedConfigConsumer = (ConfigProvider === null || ConfigProvider === void 0 ? void 0 : (_ConfigProvider$Confi = ConfigProvider.ConfigContext) === null || _ConfigProvider$Confi === void 0 ? void 0 : _ConfigProvider$Confi.Consumer) || ConfigConsumer;
export default MergedConfigConsumer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/compatible/es/CompatibleConsumer.js
// module id = 703
// module chunks = 1